import script from "./UserInfos.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfos.vue?vue&type=script&setup=true&lang=ts"

import "./UserInfos.vue?vue&type=style&index=0&id=b37b55f6&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b37b55f6"]])

export default __exports__